// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3ydia","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2dO-0"};